import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    const phoneRegex = /^[6-9]\d{9}$/;
    return phoneRegex.test(value.replace(/\s/g, ''))
      ? null
      : { invalidPhone: true };
  };
}

export function pincodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    return /^\d{6}$/.test(value) ? null : { invalidPincode: true };
  };
}

export function yearValidator(minYear = 1000, maxYear = new Date().getFullYear()): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    const year = parseInt(value);
    if (isNaN(year) || year < minYear || year > maxYear) {
      return { invalidYear: { min: minYear, max: maxYear } };
    }
    return null;
  };
}

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    const hasUppercase = /[A-Z]/.test(value);
    const hasLowercase = /[a-z]/.test(value);
    const hasNumber = /\d/.test(value);
    const hasSpecial = /[@$!%*?&#^()_+\-=]/.test(value);
    const isLongEnough = value.length >= 8;

    if (!hasUppercase || !hasLowercase || !hasNumber || !hasSpecial || !isLongEnough) {
      return { weakPassword: true };
    }
    return null;
  };
}

export function confirmPasswordValidator(passwordField: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const parent = control.parent;
    if (!parent) return null;
    const password = parent.get(passwordField)?.value;
    return password === control.value ? null : { passwordMismatch: true };
  };
}

export function isbnValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    const clean = value.replace(/[-\s]/g, '');
    if (clean.length === 10 || clean.length === 13) return null;
    return { invalidISBN: true };
  };
}

export function languageCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    return /^[A-Za-z]{2,5}$/.test(value) ? null : { invalidCode: true };
  };
}
